import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";

// Requests
/** Ermitelt die möglichen Hubs zum Standort */
export class SocketURLs {
  /** Version des aufrufes */
  public version: number;
  /** Standort zu dem die Verbindung hergestellt werden soll */
  public location: number; // HypCusNr
}

/** Generiert ein Authtoken aus Version, Location und Key */
export class SocketToken {
  /** Version des aufrufes */
  public version: number;
  /** Standort */
  public location: number; // HypCusNr
  /** Generierter Key für den Token */
  public key: string;
}

/** Synchronisation ist notwendig um SignalR und Owin zu verbinden */
export class SyncConnection {
  /** authtoken aus der Verbindung mit dem Hub */
  public token: string;
  /** key aus der Verbindung mit dem Hub */
  public key: string;
}

// Responses
export class SocketURLsModel implements ApiResponseData {
  /** mögliche Hub Server */
  public urls: string[];

  public DeserializeType(): void {
    // has no complex type
  }
}

export class SocketTokenModel implements ApiResponseData {
  /** Auth-Token */
  public token: string;

  public DeserializeType(): void {
    // has no complex type
  }
}

export class SyncConnectionModel implements ApiResponseData {
  /** synchronisation war erfolgreich */
  public success: boolean;

  public DeserializeType(): void {
    // has no complex type
  }
}

